'use strict';
import angular from 'angular';
import './tapcolors/tapcolors.module';
import './flickity/flickity.module';

angular.module('core.ui', [
    'core.tapcolors',
    'core.flickity',
]);